import { render, staticRenderFns } from "./manageIndustry.vue?vue&type=template&id=1c23ceda&scoped=true&"
import script from "./manageIndustry.vue?vue&type=script&lang=js&"
export * from "./manageIndustry.vue?vue&type=script&lang=js&"
import style0 from "./manageIndustry.vue?vue&type=style&index=0&id=1c23ceda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23ceda",
  null
  
)

export default component.exports